export const MODELOS_ENCARGO_APP = [
  { val: "Encargo de Venta", grupo: "venta" },
  { val: "Encargo de Venta 5%", grupo: "venta" },
  { val: "Encargo de Venta 4%", grupo: "venta" },
  { val: "Exclusiva de Venta", grupo: "exclusiva" },
  { val: "Exclusiva de Venta 5%", grupo: "exclusiva" },
  { val: "Exclusiva de Venta 4%", grupo: "exclusiva" },
  { val: "Otros Encargos", grupo: "otros" },
];

export const EXCL_DURACIONES_PREDEF = ["1 mes", "3 meses", "6 meses", "12 meses"];

export function esTipoEncargoExclusiva(val) {
  return /exclusiva/i.test(String(val || ""));
}

/** Modelos 4%/5%: honorarios % sobre Pventa; propietario = venta − (hon + IVA). */
export function pctHonorariosIncluidosEncargo(tipo) {
  const m = String(tipo || "").match(/\b([45])\s*%/);
  return m ? Number(m[1]) : null;
}

export function esEncargoHonorariosIncluidos(tipo) {
  return pctHonorariosIncluidosEncargo(tipo) != null;
}

/** Mediacional: diferencia venta−propietario = total honorarios (base + IVA). */
export function calcularHonorariosDesdeVentaYProp(precioVenta, precioPropietario, ivaPct = 21) {
  const pv = Number(precioVenta);
  const pp = Number(precioPropietario);
  const iva = Number(ivaPct);
  if (!Number.isFinite(pv) || !Number.isFinite(pp) || pv <= pp) return null;
  const ivaOk = Number.isFinite(iva) && iva > 0 ? iva : 21;
  const dif = pv - pp;
  const honBase = dif / (1 + ivaOk / 100);
  const ivaEuros = dif - honBase;
  const round2 = (n) => Math.round(n * 100) / 100;
  return {
    honorarios_euros: round2(honBase),
    iva_euros: round2(ivaEuros),
    honorarios_porcentaje: round2((honBase / pv) * 100),
    total_honorarios: round2(dif),
    iva_porcentaje: ivaOk,
  };
}

/** Incluidos 4%/5%: honorarios sobre precio de venta; propietario = venta − total. */
export function calcularHonorariosDesdeVentaYPct(precioVenta, pct, ivaPct = 21) {
  const pv = Number(precioVenta);
  const p = Number(pct);
  const iva = Number(ivaPct);
  if (!Number.isFinite(pv) || pv <= 0 || !Number.isFinite(p) || p <= 0) return null;
  const ivaOk = Number.isFinite(iva) && iva > 0 ? iva : 21;
  const honBase = pv * (p / 100);
  const ivaEuros = honBase * (ivaOk / 100);
  const total = honBase + ivaEuros;
  const round2 = (n) => Math.round(n * 100) / 100;
  return {
    honorarios_euros: round2(honBase),
    iva_euros: round2(ivaEuros),
    honorarios_porcentaje: round2(p),
    total_honorarios: round2(total),
    iva_porcentaje: ivaOk,
    // Propietario = venta − (honorarios + IVA); p.ej. 225.000 − 13.612,50 = 211.387,50
    precio_propietario: round2(pv - total),
  };
}

/** Precio que va al PDF del encargo: propietario si mediacional; venta si % incluido. */
export function precioPdfEncargo({ tipoEncargo, precioVenta, precioPropietario }) {
  if (esEncargoHonorariosIncluidos(tipoEncargo)) {
    return precioVenta != null ? precioVenta : precioPropietario;
  }
  return precioPropietario != null ? precioPropietario : precioVenta;
}

export function exclusivaHoyIso() {
  const dt = new Date();
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const dd = String(dt.getDate()).padStart(2, "0");
  return `${dt.getFullYear()}-${mm}-${dd}`;
}

export function exclusivaMesesDeDuracion(txt) {
  const m = String(txt || "").toLowerCase().match(/(\d+)\s*mes/);
  return m ? parseInt(m[1], 10) || 0 : 0;
}

export function exclusivaLabelMeses(meses) {
  const n = parseInt(meses, 10) || 0;
  if (n < 1) return "";
  return n === 1 ? "1 mes" : `${n} meses`;
}

export function exclusivaFechaMasMeses(isoYmd, meses) {
  const parts = String(isoYmd || "").split("-");
  if (parts.length < 3) return "";
  const y = parseInt(parts[0], 10);
  const mo = parseInt(parts[1], 10) - 1;
  const d = parseInt(parts[2], 10);
  if ([y, mo, d].some((x) => Number.isNaN(x))) return "";
  const dt = new Date(y, mo, d);
  dt.setMonth(dt.getMonth() + (meses || 0));
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const dd = String(dt.getDate()).padStart(2, "0");
  return `${dt.getFullYear()}-${mm}-${dd}`;
}

export function exclusivaMesesEntreFechas(desdeIso, hastaIso) {
  const a = String(desdeIso || "").split("-");
  const b = String(hastaIso || "").split("-");
  if (a.length < 3 || b.length < 3) return 0;
  const y1 = parseInt(a[0], 10);
  const m1 = parseInt(a[1], 10);
  const d1 = parseInt(a[2], 10);
  const y2 = parseInt(b[0], 10);
  const m2 = parseInt(b[1], 10);
  const d2 = parseInt(b[2], 10);
  if ([y1, m1, d1, y2, m2, d2].some((x) => Number.isNaN(x))) return 0;
  let months = (y2 - y1) * 12 + (m2 - m1);
  if (d2 < d1) months -= 1;
  return months > 0 ? months : 0;
}

export function abrirPestanaEncargoGenerado(propiedadId, params) {
  const q = new URLSearchParams();
  if (params?.tipoEncargo) q.set("tipo", params.tipoEncargo);
  if (params?.soloFechaFin) q.set("solo_fecha_fin", "1");
  if (!params?.soloFechaFin && params?.duracion) q.set("duracion", params.duracion);
  if (params?.desde) q.set("desde", params.desde);
  if (params?.hasta) q.set("hasta", params.hasta);
  if (params?.precio != null && params.precio !== "") q.set("precio", String(params.precio));
  if (params?.precio_venta != null && params.precio_venta !== "") q.set("precio_venta", String(params.precio_venta));
  if (params?.precio_propietario != null && params.precio_propietario !== "") {
    q.set("precio_propietario", String(params.precio_propietario));
  }
  if (params?.honorarios_euros != null && params.honorarios_euros !== "") {
    q.set("honorarios_euros", String(params.honorarios_euros));
  }
  if (params?.iva_euros != null && params.iva_euros !== "") q.set("iva_euros", String(params.iva_euros));
  if (params?.honorarios_porcentaje != null && params.honorarios_porcentaje !== "") {
    q.set("honorarios_porcentaje", String(params.honorarios_porcentaje));
  }
  if (params?.total_honorarios != null && params.total_honorarios !== "") {
    q.set("total_honorarios", String(params.total_honorarios));
  }
  if (params?.iva_porcentaje != null && params.iva_porcentaje !== "") {
    q.set("iva_porcentaje", String(params.iva_porcentaje));
  }
  if (Array.isArray(params?.motivos) && params.motivos.length) q.set("motivos", params.motivos.join(","));
  const url = `/propiedades/${encodeURIComponent(propiedadId)}/encargo-generado?${q.toString()}`;
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

export function parsePrecioUi(raw) {
  if (raw == null || raw === "") return null;
  const s = String(raw).trim().replace(/\s/g, "").replace(/\./g, "").replace(",", ".");
  const n = Number(s.replace(/[^\d.]/g, ""));
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function formatearPrecioUi(n) {
  const x = Number(n);
  if (!Number.isFinite(x)) return "";
  return x.toLocaleString("es-ES", { maximumFractionDigits: 0 });
}
